"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = exports.RadioGroupContext = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
exports.RadioGroupContext = react_1.default.createContext(undefined);
const RadioGroup = (props) => {
    const { children, disabled, label, readOnly, value, onChange } = props;
    const [selectedValue, setSelectedValue] = react_1.default.useState(value || "");
    const onClickOption = react_1.default.useCallback((event) => {
        setSelectedValue(event.target.value);
        if (onChange) {
            onChange(event);
        }
    }, [onChange]);
    const contextValue = {
        selectedValue,
        onChange: onClickOption,
        disabled,
        readOnly
    };
    return (react_1.default.createElement(exports.RadioGroupContext.Provider, { value: contextValue },
        react_1.default.createElement(foundations_1.Box, { sx: { display: "flex", flexDirection: "column", gap: 2 } },
            react_1.default.createElement(foundations_1.Text, null, label),
            react_1.default.createElement(foundations_1.Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                } }, children))));
};
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map